export enum AggregateType {
  GradedAggregate = 'GradedAggregate',
  OneSizedAggregate = 'OneSizedAggregate',
}

export enum AsNominalParticleSize {
  FineAggregate = 'FineAggregate',
  Filler = 'Filler',
}
